<template>
  <div :class="$style.base">
    <SendTest
      v-if="showSendTestModal"
      @close="showSendTestModal = false"
    />
    <BaseGrid container>
      <BaseGrid>
        <div :class="$style.heading">
          <BaseHeading size="s">
            {{ $t('marketing.email.preview.how_your_customers') }}
          </BaseHeading>
        </div>
        <Flex :class="$style.inner">
          <BaseText
            iconBefore="refresh"
            @click="onReset"
            v-test="'reset-content'"
          >
            {{ $t('global.actions.reset_content') }}
          </BaseText>
          <BaseText
            v-if="showSendTest"
            iconBefore="paper-plane"
            @click="onSendTest"
            v-test="'send-test'"
          >
            {{ $t('global.actions.send_test') }}
          </BaseText>
        </Flex>
      </BaseGrid>
      <BaseGrid
        v-if="$screen === 'l'"
        alignRight
      >
        <BaseSwitch
          v-model="selectedView"
          :options="[
            {
              value: 'DESKTOP',
              icon: 'monitor'
            },
            {
              value: 'MOBILE',
              icon: 'mobile'
            }
          ]"
          v-test="'select-view'"
        />
      </BaseGrid>
    </BaseGrid>
  </div>
</template>

<script lang="ts">
import { storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import SendTest from '@/modules/marketing/modals/SendTest.vue';
import { useCompanyStore } from '@/stores/company';
import { useMarketingStore } from '../../../store';
import { useMarketingBuilderStore } from '../../../store/builder';

export default defineComponent({
  components: {
    SendTest,
  },
  setup() {
    const { company } = useCompanyStore();
    const builderStore = useMarketingBuilderStore();
    const { showSendTest } = storeToRefs(builderStore);
    return {
      company,
      builderStore,
      showSendTest,
    };
  },
  data() {
    return {
      showSendTestModal: false,
    };
  },
  computed: {
    selectedView: {
      get() {
        return this.builderStore.selectedView;
      },
      set(value) {
        this.builderStore.setSelectedView(value);
      },
    },
  },
  methods: {
    onReset() {
      const { resetToDefaultState } = useMarketingStore();
      resetToDefaultState();
    },
    onSendTest() {
      this.showSendTestModal = true;
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  max-width: 800px;
  width: 100%;
}

.inner {
  display: flex;
  margin-bottom: $spacing;
}

.heading {
  margin-bottom: $spacing / 2;
}
</style>
